
class ModuleSidebarShareIdea {

  private sidebar!: HTMLElement;
  private form!: HTMLFormElement;
  private rgpd!: HTMLInputElement;
  private sendButton!: HTMLButtonElement;

  constructor() {
    this._init();
  }

  _init() {
    this.sidebar = document.getElementById("sidebar-share-idea") as HTMLElement;
    if (this.sidebar) {
      this.form = document.querySelector('.sidebar-share-idea__form') as HTMLFormElement;
      this.rgpd = document.querySelector('[data-rgpd-sidebar-share-idea]') as HTMLInputElement
      this.sendButton = document.querySelector('[data-valid-sidebar-share-idea]') as HTMLButtonElement
      this._rgpd();
      this._openClose();
      this._valid();
    }
  }

  _rgpd() {
    this.rgpd.addEventListener('change', () => {
      this.sendButton.disabled = !this.rgpd.checked;
    })
  }

  _valid() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();


      const subject = (document.getElementById('objet') as HTMLInputElement).value.trim();
      const description = (document.getElementById('description') as HTMLTextAreaElement).value.trim();

      if (!subject || !description || !this.rgpd.checked) {
        alert('Veuillez remplir tous les champs et donner votre consentement.');
        return;
      }

      this._sendIdea(subject, description)
    });

  }

  async _sendIdea(subject, description) {
    const formData = new FormData();
    formData.append("action", "submit_idea");
    formData.append("nonce", (window as any).ajax.nonce);
    formData.append("subject", subject);
    formData.append("description", description);

    try {
      const response = await fetch((window as any).ajax.ajax_url, {
        method: 'POST',
        body: formData,
      })

      const result = await response.json();

      if (result.success) {
        // this.form.reset();
        // this.sendButton.disabled = true;
        this.form.style.display = 'none';
        const successMessage = document.querySelector('.sidebar-share-idea__success') as HTMLElement;
        if (successMessage) {
          successMessage.style.display = 'block';
        }
      } else {
        alert('Une erreur inattendue est survenue.');
      }
    } catch (error) {
      console.error("Erreur réseau ou serveur :", error);
    }

  }

  _openClose() {
    const sidebar_share_idea_close = document.querySelectorAll(
      '[data-close-sidebar-share-idea]'
    );

    if (sidebar_share_idea_close) {
      sidebar_share_idea_close.forEach((close) => {
        close.addEventListener('click', this._hideSidebar.bind(this));
      });
    }
  }

  _hideSidebar() {
    const sidebar_share_idea = document.getElementById('sidebar-share-idea');
    if (sidebar_share_idea && sidebar_share_idea.classList.contains('open')) {
      sidebar_share_idea.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }
}

export const moduleSidebarShareIdea = new ModuleSidebarShareIdea();


